import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, ogImage, canonical, schema, noindex = false }) => {
    const defaultTitle = 'מערכת דבורה | ניהול צי רכב וקציני בטיחות בתעבורה';
    const pageTitle = title ? (title.includes('דבורה') ? title : `${title} | מערכת דבורה`) : defaultTitle;
    const defaultDescription = 'נמאס לכם מטבלאות אקסל? מערכת דבורה מנהלת עבורכם את צי הרכב: בקרת הוצאות דלק וליסינג, התראות על טסטים וביטוחים, תיק רכב דיגיטלי וחיסכון מוכח. תאמו הדגמה קצרה';
    const metaDescription = description || defaultDescription;
    const defaultKeywords = 'מערכת דבורה, דבורה, דבורה ניהול צי רכב, מערכת דבורה, דבורה ציי רכב, דבורה קצין בטיחות בתעבורה, תוכנה לניהול צי רכב דבורה, ניהול צי רכב, קצין בטיחות בתעבורה, תיק רכב דיגיטלי, תיק נהג, הדרכות נהגים';
    const metaKeywords = keywords || defaultKeywords;
    const canonicalUrl = canonical || (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : 'https://dvorafleet.co.il/');
    const finalOgImage = ogImage || 'https://dvorafleet.co.il/logo512.png';

    return (
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={canonicalUrl} />
            
            {/* Open Graph */}
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="מערכת דבורה" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={finalOgImage} />
            <meta property="og:image:width" content="512" />
            <meta property="og:image:height" content="512" />
            <meta property="og:image:alt" content="לוגו מערכת דבורה" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={finalOgImage} />

            {/* Structured Data / JSON-LD */}
            {schema && (
                <script type="application/ld+json">
                    {typeof schema === 'string' ? schema : JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
